module.exports = __webpack_public_path__ + "img/flutter.b8ac4668.svg";